import { auth } from '../Confg/firebaseConfig';

/**
 * Renova o ID token UMA vez para repetir uma leitura que voltou `permission-denied`.
 *
 * Por que existe: logo após o login, a tela monta e dispara leituras no Firestore
 * antes de o ID token recém-emitido estar valendo. As regras negam, e a leitura
 * falha mesmo com a sessão válida — é o "Error fetching direct orders" e o
 * "[SupportWidget] mensagens indisponíveis" que apareciam entre a navegação para
 * /Authentication e a para /Home. Renovar o token e tentar de novo resolve.
 *
 * O TIMEOUT é a parte importante: `getIdToken(true)` vai à rede e, se ficar pendurado,
 * um `await` sem limite trava o fluxo que chamou — foi assim que o UserContext ficou
 * com um caminho em que a tela podia parar para sempre no "Carregando...". Aqui, se a
 * renovação não voltar a tempo, desistimos e quem chamou segue no fluxo de erro.
 *
 * @param {any} erro          erro capturado da leitura
 * @param {{timeoutMs?: number}} opcoes
 * @returns {Promise<boolean>} true = token renovado, vale tentar de novo
 */
export async function renovarTokenSePermissaoNegada(erro, { timeoutMs = 8000 } = {}) {
  const codigo = erro?.code || '';
  if (codigo !== 'permission-denied' && codigo !== 'firestore/permission-denied') return false;
  if (!auth.currentUser) return false;

  let timer;
  try {
    await Promise.race([
      auth.currentUser.getIdToken(true),
      new Promise((_, reject) => {
        timer = setTimeout(() => reject(new Error('timeout ao renovar o ID token')), timeoutMs);
      }),
    ]);
    return true;
  } catch {
    // Token realmente inválido, offline ou renovação demorada demais: não insiste.
    return false;
  } finally {
    clearTimeout(timer);
  }
}
